var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',{staticClass:"quote component"},[(_vm.config.quote)?_c('div',{staticClass:"quote__text",domProps:{"innerHTML":_vm._s(_vm.config.quote)}}):_vm._e(),_vm._v(" "),(_vm.config.cite)?_c('footer',{staticClass:"quote__cite"},[_vm._v(_vm._s(_vm.config.cite))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aa9c85a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cms/pageComponents/QuoteComponent.vue
// module id = null
// module chunks = 